import logo from './logo.svg';
import './App.css';
import Ez from './components/Ez/Ez';

function App() {
  return (
    <div className="App">
      <Ez/>
    </div>
  );
}

export default App;
